import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik } from "formik";
import {  Apitoken, Authtoken } from '../Global';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const LocalcustomersAdd = () => {
  const [backendErrors, setBackendErrors] = useState([]);
  const [menu, setMenu] = useState(false);
  const [permission, setPermission] = useState({});


  useEffect(() => {
    setPermission(FindModuleById(291)); 
    console.log(permission);

  })

  const {
    values,
    errors,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      name: "",
      phone_number: "",
      address: "",
    },
    onSubmit: (values, actions) => {
      axios
        .post("/decay-customers/add", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
        
          delete backendErrors['error'];
          actions.setSubmitting(false);
          $("#form-submit").text("Add Customer");
          if (response.data.code === 200) {
            toast.success(response.data.message);
            actions.resetForm();
            setTimeout(() => {
              window.location.href = "/local-customers";
            }, 1000);
          }  else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


const customHandleInput = (event) => {
  const Input_name = event.target.name;
  delete backendErrors[Input_name];
};
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Local Customers</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/local-customers">Local Customers</Link>
                    </li>
                    <li className="breadcrumb-item active">Add Customer</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Customer Information</h4>
                    {permission && permission.add == 1 && (
                      <form action="#" onSubmit={handleSubmit}>
                     
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label> Name</label>
                            <input
                              type="text"
                              name="name"
                              value={values.name}
                              className={
                                backendErrors.name
                                  ? "form-input form-control input-error"
                                  : "form-input form-control"
                              }
                           
                              onChange={(e) => {
                                handleChange(e);
                                customHandleInput(e);
                              }}
                               onBlur={handleBlur}
                            />
                           <small>
                              {backendErrors.name && (
                                <span className="form-error mt-1">
                                  {backendErrors.name}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label> Phone Number</label>
                            <input
                              type="text"
                              name="phone_number"
                              value={values.phone_number}
                              className={
                                backendErrors.phone_number
                                  ? "form-input form-control input-error"
                                  : "form-input form-control"
                              }
                           
                              onChange={(e) => {
                                handleChange(e);
                                customHandleInput(e);
                              }}
                               onBlur={handleBlur}
                            />
                           <small>
                              {backendErrors.phone_number && (
                                <span className="form-error mt-1">
                                  {backendErrors.phone_number}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Address</label>
                            <input
                              type="text"
                              name="address"
                              value={values.address}
                              className={
                                errors.address
                                  ? "form-input form-control input-error"
                                  : "form-input form-control"
                              }
                              onChange={(e) => {
                                handleChange(e);
                                customHandleInput(e);
                              }}
                                onBlur={handleBlur}
                            />
                            <small>
                              {backendErrors.address && (
                                <span className="form-error mt-1">
                                  {backendErrors.address}
                                </span>
                              )}
                            </small>
                          </div>
                       </div>
                      </div>
                      <small>
                              {backendErrors.status  && (
                                <span className="form-error mt-1">
                                  {backendErrors.status}
                                </span>
                              )}
                            </small>
                      <div className="text-end mt-4">
                        <button
                          type="submit" id="form-submit"
                          className="btn btn-primary"
                          disabled={isSubmitting}
                        >
                          Add Customer
                        </button>
                      </div>
                    </form>
                    )}
                  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default LocalcustomersAdd;
